import React from "react";
import NewOrdersTable from "./NewOrdersTable";
import { stateBarChanged } from "../../../redux/General/clientSideSearchActionCreators";

import { SearchTextField } from "../../../components/TextField";

import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Typography,
  Select,
  Chip,
  Fade,
} from "@material-ui/core";

import { connect } from "react-redux";
import Store from "../../../redux/Store";
import { useStyles } from "../../../styles/mainStyles";

const NewOrders = ({ activeOrders }) => {
  let border = useStyles();
  const orderStates = [
    "لغو شده",
    "تحویل شد",
    "تایید پرداخت",
    "ارجاع از دفتر",
    "در حال چاپ",
    "سفارش ثبت شد",
    "آماده ارسال",
    "ارسال شد",
  ];
  const searchChangeHandler = (value, action) => {
    Store.dispatch(action(value));
  };

  return (
    <Fade in={true} timeout={500}>
      <Grid container justifyContent="center" style={{ height: "100%" }}>
        <Grid
          container
          item
          xs={12}
          spacing={2}
          style={{
            backgroundColor: "white",
            boxShadow: "0 3px 6px rgba(0,0,0,0.2)",
            borderRadius: 6,
            height: "100%",
          }}
        >
          <Grid container direction="row" alignItems="center" item xs={12}>
            <Typography style={{ marginLeft: "10px" }} variant="body1">
              سفارش ها
            </Typography>
            <Chip
              label={activeOrders.data.length}
              color="primary"
              style={{ minWidth: 50, fontSize: "15px" }}
              size="small"
              variant="outlined"
            />
          </Grid>
          <Grid
            item
            container
            xs={12}
            style={{ height: "90%", margin: 8 }}
            className={border.border}
          >
            <Grid
              container
              item
              xs={12}
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start"
              style={{ height: 50 }}
            >
              <Grid item sm={8} xs={7}>
                <SearchTextField />
              </Grid>

              <Grid item sm={3} xs={5}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel>وضعیت</InputLabel>
                  <Select
                    defaultValue=""
                    color="primary"
                    label="وضعیت"
                    onClick={(e) => {
                      let data = e.target.value;

                      searchChangeHandler(
                        data === undefined || data === 0 ? "" : data,
                        stateBarChanged
                      );
                    }}
                  >
                    <MenuItem value="">همه</MenuItem>

                    {orderStates.map((item, index) => (
                      <MenuItem key={index} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <Grid item xs={12} style={{ height: "calc(100% - 50px)" }}>
              <NewOrdersTable />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Fade>
  );
};
const mapStateToProps = (props) => {
  const { OrderReducer } = props;
  const { activeOrders } = OrderReducer;

  return { activeOrders };
};

export default connect(mapStateToProps)(NewOrders);
